'use strict';

export default class EventFiltersController {
	/*@ngInject*/
	constructor(Auth, $state, $http, $log, $scope) 
	{
		//console.log("::EventFiltersController");
		
		$http.post("/api/frontend/events/entities")
		.then(response =>
		{
			$scope.vm.filters = response.data;
			//console.log(response.data);
		});
	}

	
}



// WEBPACK FOOTER //
// ./client/app/frontend/events/event_filters.controller.js